<div class='admissions-prospects-page'>

	<toolbar icon='Admissions'>

		<button class="btn btn-light" (click)='admissionsService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i
				class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>

		<!-- <button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Prospects", "Applications", "Seats","Engagements"]' [pageService]='pageService'
		(layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<admissions-prospects-views-part></admissions-prospects-views-part>
		</ng-template>

		<ng-template pageTab2>
			<admissions-prospects-tab-1-part></admissions-prospects-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<admissions-prospects-tab-2-part></admissions-prospects-tab-2-part>
		</ng-template>

		<ng-template pageTab4>
			<admissions-prospects-tab-3-part></admissions-prospects-tab-3-part>
		</ng-template>
	</page-tabs>

</div>